import React, { useEffect, useState } from 'react';
import './Home.css';
import '@fontsource/manrope'; // Default weight is 400




import Icons from './Icons';
import FilterHome from './FilterHome';
import Industries from './Industries';
import WhyChooseUs from './WhyChooseUs';
import CaseStudy from './CaseStudy';
import Approach from './Approach';
import Client from './Client';
import Form from './Form';
import Footer from './Footer';
import Map from './Map';


import bg3 from '../../video/bg3.mp4';
import bg2 from '../../video/bg2.mp4';
import bg1 from '../../video/bg1.mp4';

export default function Home() {
  const videoSources = [bg1, bg2, bg3];
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [isVideoChanging, setIsVideoChanging] = useState(false);

  useEffect(() => {
    const videoInterval = setInterval(() => {
      setIsVideoChanging(true);
      setTimeout(() => {
        setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videoSources.length);
        setIsVideoChanging(false);
      }, 1000); // Delay for fade-out transition to complete
    }, 8000); 

    return () => clearInterval(videoInterval); // Cleanup interval on unmount
  }, []);

  

  return (
    <>
      <div className="hero-section">
        {/* First video */}
        {/* <video
          className={`background-video ${isVideoChanging ? 'fade-out' : ''}`}
          autoPlay
          muted
          loop
        >
          <source src={videoSources[currentVideoIndex]} type="video/mp4" />
        </video> */}

        {/* Second video for smooth fade-in */}
        {/* <video
          className={`background-video ${isVideoChanging ? 'fade-in' : ''}`}
          autoPlay
          muted
          loop
          key={currentVideoIndex} // Ensure video reloads on index change
        >
          <source src={videoSources[(currentVideoIndex + 1) % videoSources.length]} type="video/mp4" />
        </video> */}

<video className="background-video" autoPlay muted loop>
          <source src={bg1} type="video/mp4" />
        </video>

        <div className="hero-content">
    {/* Text content in a column */}
    <div className="hero-text">
      <h1 className="hero-content-h">CUSTOMIZED SOFTWARE SOLUTIONS FOR BUSINESS</h1>
      <p>
        We worked with Sammarshya on a startup project. They are a professional
        and flexible team with different experience in many frameworks.
      </p>
    </div>

    {/* Button beside the text */}
    <button className="cta-button"> LET'S DISCUSS YOUR PROJECT</button>
  </div>
</div>

      
          <Icons/>
      <FilterHome />
      <Industries />
      <WhyChooseUs />
      <CaseStudy />
      <Approach />
      <Client />
      <Form />
      <Map />
      <Footer />
    </>
  );
}
